import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
} from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Routes, withInMemoryScrolling } from '@angular/router';
import {importProvidersFrom, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection} from "@angular/core";
import { GtagModule } from "angular-gtag";

export interface CoreOptions {
  routes: Routes;
}

export function provideCore({ routes }: CoreOptions) {
  return [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    importProvidersFrom(
      GtagModule.forRoot({ trackingId: 'G-LVWRMLMSMV', trackPageviews: true }),
    ),
    provideClientHydration(withEventReplay(), withIncrementalHydration()),
    provideHttpClient(withFetch(), withInterceptors([])),
    provideAnimations(),

    // other 3rd party libraries providers like NgRx, provideStore()
    // other application specific providers and setup
    // perform initialization, has to be last
  ];
}
